export const PARENTS_INFO_BANNER_TOTAL_HEIGHT = 860
export const PARENTS_INFO_BANNER_VERTICAL_PADDING = 48
export const PARENTS_INFO_BANNER_HEIGHT =
    PARENTS_INFO_BANNER_TOTAL_HEIGHT - PARENTS_INFO_BANNER_VERTICAL_PADDING * 2

// Stele icon row offset from viewport top when the popup covers the full screen.
export const PHASE_TRANSITION_ICONS_STELE_TOP_VIEWPORT =
    PARENTS_INFO_BANNER_TOTAL_HEIGHT + PARENTS_INFO_BANNER_VERTICAL_PADDING
